// extracted by mini-css-extract-plugin
export var active = "flowsAi-module--active--f1933";
export var flowsAiPage = "flowsAi-module--flowsAiPage--2d36a";
export var inactive = "flowsAi-module--inactive--22303";